module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2026-04-27 at 21.26.54 (1) - Copy.e424b097.jpeg";